module.exports = __WEBPACK_EXTERNAL_MODULE_59__;


//////////////////
// WEBPACK FOOTER
// external {"root":["ng","common"],"commonjs":"@angular/common","commonjs2":"@angular/common","amd":"@angular/common"}
// module id = 59
// module chunks = 0